import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { createStyles, Dialog, DialogContent, makeStyles } from '@material-ui/core';
var useStyles = makeStyles(function (theme) {
  return createStyles({
    header: {
      margin: 0,
      padding: theme.spacing(2)
    },
    body: function body(props) {
      return {
        margin: 0,
        padding: theme.spacing(props.contentPadding)
      };
    }
  });
});

var Modal = function Modal(_ref) {
  var disableBackdropClick = _ref.disableBackdropClick,
      dsOnClose = _ref.dsOnClose,
      e2e = _ref.e2e,
      _ref$maxWidth = _ref.maxWidth,
      maxWidth = _ref$maxWidth === void 0 ? 'lg' : _ref$maxWidth,
      _ref$contentPadding = _ref.contentPadding,
      contentPadding = _ref$contentPadding === void 0 ? 2 : _ref$contentPadding,
      _ref$open = _ref.open,
      open = _ref$open === void 0 ? false : _ref$open,
      id = _ref.id,
      header = _ref.header,
      body = _ref.body,
      footer = _ref.footer,
      getHeaderSlot = _ref.getHeaderSlot,
      getBodySlot = _ref.getBodySlot,
      getFooterSlot = _ref.getFooterSlot;
  var classes = useStyles({
    contentPadding: contentPadding
  });
  var headerCb = React.useCallback(function (node) {
    getHeaderSlot && getHeaderSlot(node);
  }, [getHeaderSlot]);
  var bodyCb = React.useCallback(function (node) {
    getBodySlot && getBodySlot(node);
  }, [getBodySlot]);
  var footerCb = React.useCallback(function (node) {
    getFooterSlot && getFooterSlot(node);
  }, [getFooterSlot]);
  var hasHeader = Boolean(header || getHeaderSlot);
  var hasBody = Boolean(body || getBodySlot);
  var hasFooter = Boolean(footer || getFooterSlot);
  var headerId = "".concat(id, "-header");
  var bodyId = "".concat(id, "-body");
  return /*#__PURE__*/React.createElement(Dialog, _extends({
    maxWidth: maxWidth,
    disableBackdropClick: disableBackdropClick
  }, e2e && {
    'data-e2e': e2e
  }, {
    open: open,
    onClose: dsOnClose
  }, hasHeader && {
    'aria-labelledby': headerId
  }, hasBody && {
    'aria-describedby': bodyId
  }), hasHeader && /*#__PURE__*/React.createElement("div", _extends({
    id: headerId,
    ref: headerCb
  }, e2e && {
    'data-e2e': "".concat(e2e, "-header")
  }), header), hasBody && /*#__PURE__*/React.createElement(DialogContent, _extends({
    id: bodyId,
    dividers: true
  }, e2e && {
    'data-e2e': "".concat(e2e, "-body")
  }, {
    className: classes.body,
    ref: bodyCb
  }), body), hasFooter && /*#__PURE__*/React.createElement("div", _extends({
    ref: footerCb
  }, e2e && {
    'data-e2e': "".concat(e2e, "-footer")
  }), footer));
};

export default Modal;

try {
  Modal.__docgenInfo = {
    description: '',
    displayName: 'Modal',
    methods: [],
    props: {
      body: {
        defaultValue: null,
        description: '',
        name: 'body',
        required: false,
        type: {
          name: 'ReactNode'
        }
      },
      footer: {
        defaultValue: null,
        description: '',
        name: 'footer',
        required: false,
        type: {
          name: 'ReactNode'
        }
      },
      getBodySlot: {
        defaultValue: null,
        description: '',
        name: 'getBodySlot',
        required: false,
        type: {
          name: '(elem: HTMLElement) => any'
        }
      },
      getFooterSlot: {
        defaultValue: null,
        description: '',
        name: 'getFooterSlot',
        required: false,
        type: {
          name: '(elem: HTMLElement) => any'
        }
      },
      getHeaderSlot: {
        defaultValue: null,
        description: '',
        name: 'getHeaderSlot',
        required: false,
        type: {
          name: '(elem: HTMLElement) => any'
        }
      },
      e2e: {
        defaultValue: null,
        description: '',
        name: 'e2e',
        required: false,
        type: {
          name: 'string'
        }
      },
      header: {
        defaultValue: null,
        description: '',
        name: 'header',
        required: false,
        type: {
          name: 'ReactNode'
        }
      },
      id: {
        defaultValue: null,
        description: 'Unique ID for accessibility purposes.',
        name: 'id',
        required: true,
        type: {
          name: 'string'
        }
      },
      dsOnClose: {
        defaultValue: null,
        description: '',
        name: 'dsOnClose',
        required: true,
        type: {
          name: '(event: any, reason: "backdropClick" | "escapeKeyDown" | "closeButtonClick") => void'
        }
      },
      open: {
        defaultValue: {
          value: false
        },
        description: '',
        name: 'open',
        required: false,
        type: {
          name: 'boolean'
        }
      },
      disableBackdropClick: {
        defaultValue: null,
        description: '',
        name: 'disableBackdropClick',
        required: false,
        type: {
          name: 'boolean'
        }
      },
      maxWidth: {
        defaultValue: {
          value: 'lg'
        },
        description: '',
        name: 'maxWidth',
        required: false,
        type: {
          name: 'false | "xs" | "sm" | "md" | "lg" | "xl"'
        }
      },
      contentPadding: {
        defaultValue: {
          value: 2
        },
        description: 'Number of theme spaces to pad the Modal Content',
        name: 'contentPadding',
        required: false,
        type: {
          name: 'number'
        }
      }
    }
  };
} catch (e) {}
//# sourceMappingURL=index.js.map